<template>
  <b-navbar type="dark" variant="info">
    <b-nav-text class="mr-3">
      <a href="#" @click="burger_click">
        <b-icon icon="list" scale="2"/>
      </a>
    </b-nav-text>
    <b-nav-form v-if="has_search_permissions" @submit.stop class="d-none d-sm-block">
      <SearchForm></SearchForm>
    </b-nav-form>
    <!-- Right aligned nav items -->
    <b-navbar-nav v-if="authenticated" class="ml-auto">
      <b-nav-item v-if="authenticated && has_search_permissions" class="d-block d-sm-none mr-3" to="/search">
        <b-icon icon="search"/>
      </b-nav-item>
      <b-nav-item active class="mr-3" to="/dl">
        <b-icon
            icon="bell"
            :class="notification_classes"
            :variant="userdata.notification_count ? 'dark' : null"
        />
        <b-badge
            v-show="userdata.notification_count"
            variant="danger"
            append
            class="notification-badge"
        >
          {{ userdata.notification_count }}
        </b-badge>
      </b-nav-item>
      <b-nav-item-dropdown right>
        <!-- Using 'button-content' slot -->
        <template #button-content>
          <em>{{ userdata.fullname }}</em>
        </template>
        <b-dropdown-text>Profile</b-dropdown-text>
        <b-dropdown-item v-if="userdata.is_superuser" href="/admin"
        >Admin backend
        </b-dropdown-item>
        <b-dropdown-item href="#" @click.prevent="perform_logout"
        >Sign Out
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import SearchForm from "@/components/interface/SearchForm.vue";
import VueRamUtils from "vue-ram-utils";

const axios_token = VueRamUtils.axios_token;
export default {
  name: "TemplateHeader",
  props: {
    collapsed: Boolean,
    isOnMobile: Boolean,
  },
  components: {
    SearchForm: SearchForm,
  },
  data() {
    return {
      deb_promise: null,
      timer_handle: null,
      hasnewnotify: false,
    };
  },
  mounted() {
    const self = this;
    this.timer_handle = window.setInterval(function () {
      self.refresh_userinfo().catch(axios_token.centralerror(self));
    }, 30000);
  },
  beforeDestroy() {
    console.info("TemplateHeader", this.timer_handle, "clear interval");
    clearInterval(this.timer_handle);
  },
  methods: {
    ...mapActions("auth", ["logout", "refresh_userinfo"]),

    burger_click: function () {
      this.$emit("burghertoggle");
    },
    perform_logout: function () {
      const self = this;
      this.logout().then(function () {
        self.$nextTick(function () {
          self.$router.push("/login");
        });
      });
    },
  },
  watch: {
    "userdata.notification_count": function (newValue, oldValue) {
      if (oldValue < newValue && newValue > 0) {
        console.info("watch userdata.notification_count", newValue, oldValue);
        this.$bvToast.toast(`Hai ${newValue - oldValue} nuove scadenze`, {
          title: "Scadenziario",
          variant: "primary",
          autoHideDelay: 3000,
          appendToast: true,
        });
      } else {
        const self = this;
        this.hasnewnotify = true;
        setTimeout(function () {
          self.hasnewnotify = false;
        }, 2000);
      }
    },
  },
  computed: {
    ...mapState("auth", ["userdata"]),
    ...mapGetters("auth", ["authenticated"]),
    ...mapGetters("search", ["search_type_choices"]),
    has_search_permissions: function () {
      return Object.keys(this.search_type_choices).length > 0;
    },
    notification_classes: function () {
      const classes = ["bell-icon"];
      if (this.userdata.notification_count) {
        classes.push("bell");
      }
      if (this.hasnewnotify) {
        classes.push("bell-hilight");
      }
      return classes;
    },
  },
};
</script>

<style>
.notification-badge {
  position: relative;
  top: -10px;
  right: 7px;
  border: $white 1px solid;
  margin-right: -18px;
  font-size: 65%;
}

.navbar-nav > li {
  float: none;
  display: inline-block;
}

.bell-icon {
  transition: all 2s;
}

.bell-hilight {
  color: yellow !important;
}

.bell {
  display: block;
  -webkit-animation: ring 4s 0.7s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 4s 0.7s ease-in-out infinite;
  -moz-transform-origin: 50% 4px;
  animation: ring 4s 0.7s ease-in-out infinite;
  transform-origin: 50% 4px;
}

@-webkit-keyframes ring {
  0% {
    -webkit-transform: rotateZ(0);
  }
  1% {
    -webkit-transform: rotateZ(30deg);
  }
  3% {
    -webkit-transform: rotateZ(-28deg);
  }
  5% {
    -webkit-transform: rotateZ(34deg);
  }
  7% {
    -webkit-transform: rotateZ(-32deg);
  }
  9% {
    -webkit-transform: rotateZ(30deg);
  }
  11% {
    -webkit-transform: rotateZ(-28deg);
  }
  13% {
    -webkit-transform: rotateZ(26deg);
  }
  15% {
    -webkit-transform: rotateZ(-24deg);
  }
  17% {
    -webkit-transform: rotateZ(22deg);
  }
  19% {
    -webkit-transform: rotateZ(-20deg);
  }
  21% {
    -webkit-transform: rotateZ(18deg);
  }
  23% {
    -webkit-transform: rotateZ(-16deg);
  }
  25% {
    -webkit-transform: rotateZ(14deg);
  }
  27% {
    -webkit-transform: rotateZ(-12deg);
  }
  29% {
    -webkit-transform: rotateZ(10deg);
  }
  31% {
    -webkit-transform: rotateZ(-8deg);
  }
  33% {
    -webkit-transform: rotateZ(6deg);
  }
  35% {
    -webkit-transform: rotateZ(-4deg);
  }
  37% {
    -webkit-transform: rotateZ(2deg);
  }
  39% {
    -webkit-transform: rotateZ(-1deg);
  }
  41% {
    -webkit-transform: rotateZ(1deg);
  }

  43% {
    -webkit-transform: rotateZ(0);
  }
  100% {
    -webkit-transform: rotateZ(0);
  }
}

@-moz-keyframes ring {
  0% {
    -moz-transform: rotate(0);
  }
  1% {
    -moz-transform: rotate(30deg);
  }
  3% {
    -moz-transform: rotate(-28deg);
  }
  5% {
    -moz-transform: rotate(34deg);
  }
  7% {
    -moz-transform: rotate(-32deg);
  }
  9% {
    -moz-transform: rotate(30deg);
  }
  11% {
    -moz-transform: rotate(-28deg);
  }
  13% {
    -moz-transform: rotate(26deg);
  }
  15% {
    -moz-transform: rotate(-24deg);
  }
  17% {
    -moz-transform: rotate(22deg);
  }
  19% {
    -moz-transform: rotate(-20deg);
  }
  21% {
    -moz-transform: rotate(18deg);
  }
  23% {
    -moz-transform: rotate(-16deg);
  }
  25% {
    -moz-transform: rotate(14deg);
  }
  27% {
    -moz-transform: rotate(-12deg);
  }
  29% {
    -moz-transform: rotate(10deg);
  }
  31% {
    -moz-transform: rotate(-8deg);
  }
  33% {
    -moz-transform: rotate(6deg);
  }
  35% {
    -moz-transform: rotate(-4deg);
  }
  37% {
    -moz-transform: rotate(2deg);
  }
  39% {
    -moz-transform: rotate(-1deg);
  }
  41% {
    -moz-transform: rotate(1deg);
  }

  43% {
    -moz-transform: rotate(0);
  }
  100% {
    -moz-transform: rotate(0);
  }
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(30deg);
  }
  3% {
    transform: rotate(-28deg);
  }
  5% {
    transform: rotate(34deg);
  }
  7% {
    transform: rotate(-32deg);
  }
  9% {
    transform: rotate(30deg);
  }
  11% {
    transform: rotate(-28deg);
  }
  13% {
    transform: rotate(26deg);
  }
  15% {
    transform: rotate(-24deg);
  }
  17% {
    transform: rotate(22deg);
  }
  19% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(18deg);
  }
  23% {
    transform: rotate(-16deg);
  }
  25% {
    transform: rotate(14deg);
  }
  27% {
    transform: rotate(-12deg);
  }
  29% {
    transform: rotate(10deg);
  }
  31% {
    transform: rotate(-8deg);
  }
  33% {
    transform: rotate(6deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  37% {
    transform: rotate(2deg);
  }
  39% {
    transform: rotate(-1deg);
  }
  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}
</style>
